import React, {Component, Fragment} from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import socket from '../../helpers/socket';
import ptiqcsLogo from '../../assets/images/logos/ptiqcs-logo.png';
import {isStationOperator} from "../../helpers/utils";
import Modal from "react-bootstrap-modal";
import {Error, Input} from "./form";
import Validator from "validatorjs";
import api from "../../helpers/api";


class TopNavHeader extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			showPasswordModal: false,
			errors: {},
			passwordForm: {
				password: ''
			}
		}
	}

	openModal = () => this.setState({ showPasswordModal: true });
	closeModal = () => this.setState({ showPasswordModal: false, passwordForm: {password: ''}, errors: {}});

	updateState = (object) => {
		this.setState({
			passwordForm: {
				...this.state.passwordForm,
				...object
			}
		})
	};

	formSubmit = async (e) => {
		e.preventDefault();
		const {logoutAction, session} = this.props;
		const {passwordForm} = this.state;

		let validation = new Validator(passwordForm, {'password': 'required'}, {"required.password": "Password is required"});
		if(validation.fails()) {
			return this.setState({errors: validation.errors.all()});
		}

		try {
			await api.post('/auth/validate-password', passwordForm);
			this.closeModal();

			if(session) {
				socket().emit('user.leave.personal', session.user_id);
				socket().emit('role.leave', session.active_role_id);
			}
			logoutAction();
		} catch (error) {
			this.setState({errors: {
				password: [error.message]
			}});
		}
	};

	_logoutAction = (e) => {
		e.preventDefault();
		const {logoutAction, session} = this.props;

		if(isStationOperator(session)) {
			return this.openModal();
		}

		if(session) {
			socket().emit('user.leave.personal', session.user_id);
			socket().emit('role.leave', session.active_role_id);
		}
		logoutAction();
	};

	render() {
		const {translate} = this.props;
		const {showPasswordModal, passwordForm, errors} = this.state;

		return (
			<Fragment>
				<header className="main-header">
					<nav className="navbar navbar-static-top">
						<div className="container">
							<Link to="/dashboard" style={{background: "#000000"}}>
								<img src={ptiqcsLogo} alt="PTIQCS" height="50"/>
							</Link>

							<div className="navbar-custom-menu">
								<ul className="nav navbar-nav">
									<li>
										<Link to="/auth/logout" onClick={this._logoutAction}>
											<i className="fa fa-sign-out" aria-hidden="true"/>
											<span className="nav-item-text hidden-sm hidden-xs">
												{ translate('header.logout') }
											</span>
										</Link>
									</li>
								</ul>
							</div>
						</div>
					</nav>
				</header>

				<Modal dialogClassName='modal-sm' show={showPasswordModal} onHide={this.closeModal} >
					<Modal.Header closeButton>
						<Modal.Title id='PasswordModalHeader'>Password</Modal.Title>
					</Modal.Header>
					<form onSubmit={this.formSubmit}>
						<Modal.Body>
							<div className="form-group">
								<Input type="password" value={passwordForm.password} autoComplete="off" onChange={e => this.updateState({password: e.target.value})} />
								{errors.password && <Error text={errors.password[0]} />}
							</div>
						</Modal.Body>
						<Modal.Footer>
							<button type="submit" className="btn btn-primary">Logout</button>
						</Modal.Footer>
					</form>
				</Modal>
			</Fragment>
		)
	}
}

TopNavHeader.propTypes = {
	activeLocale: PropTypes.string.isRequired,
	session: PropTypes.object.isRequired,
	translate: PropTypes.func.isRequired,
	logoutAction: PropTypes.func.isRequired,
	switchLanguageAction: PropTypes.func.isRequired
};

export default TopNavHeader
